window.addEventListener("optionChanged", function(event) {

    const fulfillmentType = event.detail.fulfillmentType;
    const select = document.querySelector('#select-shipping-range');
    const ctm_cart_block = document.querySelector('.cart__blocks.ctm_cart_block');

    if (!select) {
        console.warn('Dropdown #select-shipping-range not found.');
        return;
    }

    if (fulfillmentType === "pickup") {
        select.value = '';
       ctm_cart_block.classList.add('adwoption');
       ctm_cart_block.classList.remove('hidelastoption');
    } else if (fulfillmentType === "shipping") {
        select.selectedIndex = 0;
       ctm_cart_block.classList.remove('adwoption');
      ctm_cart_block.classList.add('hidelastoption');
    }
});


